<!-- error message -->
<div *ngIf="isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>

    </div>
</div>

<div *ngIf="!isErrorMessage">
    <h2 class="sectionTitle">{{ 'SHARED.REPORTS.EBOOKING_REPORT.EBOOKING_REPORT_NAME' | translate }}</h2>
    <div class="services-filter">
        
        <div class="form-container">
            <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>


            <div class="form-group">
                <label
                    for="txtCreationDateFrom">{{ 'SHARED.REPORTS.EBOOKING_REPORT.REQUEST_SUBMISSION_DATE_FROM' | translate}}</label>
                <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" autocomplete="off"
                    #input="bsDatepicker" [(ngModel)]="creationDateFrom" bsDatepicker [minDate]='null'
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
                <div class="red" *ngIf="showFromDateGreaterThanTodayDateMessage">
                    {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
                </div>
                <div class="red" *ngIf="showFromDateGreaterThanToDateMessage">
                    {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
                </div>

            </div>
            <div class="form-group">
                <label
                    for="txtCreationDateTo">{{ 'SHARED.REPORTS.EBOOKING_REPORT.REQUEST_SUBMISSION_DATE_TO' | translate}}</label>
                <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" autocomplete="off"
                    #input="bsDatepicker" [(ngModel)]="creationDateTo" bsDatepicker [minDate]='null'
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
            </div>
            <div class="form-group">
                <label for="dllServiceName">{{ 'SHARED.MYREQUESTS.ServiceName' | translate}}</label>
                <select class="form-control" id="dllServiceName" name="dllServiceName" [(ngModel)]="serviceId" (change)="changeService(serviceId, false)">
                    <option value="">--- {{'SHARED.AllServices' | translate}} ---</option>
                    <option *ngFor="let service of servicesList" value="{{service.Id}}">
                        {{lang == "Ar" ? service.NameAR : service.NameEN}}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label for="dllStatus">{{ 'SHARED.MYREQUESTS.Status' | translate}}</label>
                <select class="form-control" id="dllStatus" name="dllStatus" [(ngModel)]="serviceStatus">
                    <option value="">--- {{'SHARED.AllStatuses' | translate}} ---</option>
                    <option *ngFor="let status of statusesList" value="{{status.Id}}">
                        {{lang == "Ar" ? status.StatusAR : status.StatusEN}}
                    </option>
                </select>
            </div>

            <div class="form-group">
                <label for="txtRequestNumber">{{ 'SHARED.REPORTS.EBOOKING_OBJECT.RequestNumber' | translate}}</label>
                <input type="text" class="form-control" [(ngModel)]="requestNumber" autocomplete="off">
            </div>
            <!-- Transit Date -->
            <div class="form-group" title="{{ 'SHARED.REPORTS.EBOOKING_REPORT.FeesEstimationAndTransitservicesFilterOnly' | translate }}">
                <label
                    for="textTransitDate">{{ 'SHARED.REPORTS.EBOOKING_REPORT.TRANSIT_DATE' | translate}}</label>
                <input class="form-control" id="textTransitDate" name="textTransitDate" autocomplete="off"
                    #input="bsDatepicker" [(ngModel)]="transitDate" bsDatepicker [minDate]='null'
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
            </div>
                       <!-- ETA -->
            <div class="form-group" title="{{ 'SHARED.REPORTS.EBOOKING_REPORT.FeesEstimationAndTransitservicesFilterOnly' | translate }}">
                        <label
                            for="txtEta">{{ 'SHARED.REPORTS.EBOOKING_REPORT.Eta' | translate}}</label>
                        <input class="form-control" id="txtEta" name="txtEta" autocomplete="off"
                            #input="bsDatepicker" [(ngModel)]="eta" bsDatepicker [minDate]='null'
                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
                    </div>
                        <!-- Sail Directions -->
            <div class="form-group" title="{{ 'SHARED.REPORTS.EBOOKING_REPORT.FeesEstimationAndTransitservicesFilterOnly' | translate }}">
                            <label for="ddlSailDirections">{{ 'SHARED.REPORTS.EBOOKING_REPORT.DIRECTIONS' | translate}}</label>
                            <select [(ngModel)]=" this.directionId" class="form-control" id="ddlSailDirections">
                                <option value="">--- {{'SHARED.REPORTS.EBOOKING_REPORT.ALL_DIRECTIONS' | translate}} ---</option>
                                <option *ngFor="let direction of sailDirections" value="{{direction?.Id}}">
                                    {{lang == "Ar" ? direction?.DirectionAR : direction?.Direction}}
                                </option>
                            </select>
                        </div>

    <!-- Vessel Name  -->
            <div class="form-group" title="{{ 'SHARED.REPORTS.EBOOKING_REPORT.FeesEstimationAndTransitservicesFilterOnly' | translate }}" >
        <label for="txtVesselName">{{ 'SHARED.REPORTS.EBOOKING_REPORT.VesselName' | translate}}</label>
        <input type="text" class="form-control" [(ngModel)]="vesselName" autocomplete="off">
             </div>

        <!--Is Payed -->
        <!-- <div  class="form-group">
            <label for="IsPayedCheckbox">{{ 'SHARED.REPORTS.EBOOKING_REPORT.IsPayed' | translate }}</label>
          <div class="custom-checkbox">
            <input type="checkbox"  name="IsPayedCheckbox" id="IsPayedCheckbox"
            [(ngModel)]="isPayed">
            <label for="IsPayedCheckbox">Yes</label>
          </div>
        </div> -->

        
                <!--Is Payed -->
             <div class="form-group" title="{{ 'SHARED.REPORTS.EBOOKING_REPORT.TransitServiceFilterOnly' | translate }}">
                        <label >{{ 'SHARED.REPORTS.EBOOKING_REPORT.IsPayed' | translate }}</label>

                        <div class="form-custom-inputs">
                            <div class="custom-Radio">
                                <input type="radio" [(ngModel)]="isPayed"  id="payedYes" name="payedYes" value="true"  />
                                <label for="payedYes">{{ 'SHARED.REPORTS.EBOOKING_REPORT.Yes' | translate }}</label>
                            </div>
                            <div class="custom-Radio">
                                <input type="radio" [(ngModel)]="isPayed" id="payedNo" name="payedNo" value="false" />
                                <label for="payedNo">{{ 'SHARED.REPORTS.EBOOKING_REPORT.No' | translate }}</label>
                            </div>
<!-- 
                            <div class="custom-Radio">
                                    <input type="radio" [(ngModel)]="isPayed" id="payedBoth" name="payedBoth" value="" />
                                    <label for="payedBoth">{{ 'SHARED.REPORTS.EBOOKING_REPORT.PayedBoth' | translate }}</label>
                                </div> -->

                        </div>
                    </div>


             <div class="form-group" *ngIf="isAdmin">
                <label for="txtUserName">{{ 'SHARED.REPORTS.EBOOKING_OBJECT.RequestorName' | translate}}</label>
                <div class="ng-autocomplete">
                    <ng-autocomplete [data]="agentsNamesList" [searchKeyword]="keyword" autocomplete="off"
                        (selected)='selectAgentNameEvent($event)' (inputChanged)='onAgentsNamesSearchChange($event)'
                        (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate"
                        [minQueryLength]="autoCompleteMinQueryLength" [notFoundTemplate]="notFoundTemplate"
                        [isLoading]="isAutoCompleteLoading" [(ngModel)]="userName"
                        placeHolder="{{'SHARED.REPORTS.AGENT_NAME_MIN_CHARS' | translate }}">
                    </ng-autocomplete>

                    <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item"></a>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="this.agentNameNotFoundMessage"></div>
                    </ng-template>
                </div>
             </div>


        </div>

        <div class="btns-holder text-center">
            <input type="button" class="btn btn-primary SCAcustomBtn" (click)="getEBookingReportData()"
                value="{{ 'SHARED.Search' | translate}}" />
            <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetMyEBookingReport()"
                value="{{ 'SHARED.ResetSearch' | translate}}" />
            <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="ExportExcel()"
                value="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}" />
        </div>
    </div>
    <!-- <app-grid-view #EBookingReport [HasMenu]="HasMenu"></app-grid-view> -->


<div class="noMenu-table">
    <!-- <app-grid-view #MyAgents [IsHtml]="IsHtml" [HasMenu]="HasMenu" (loadItemsMenu)="loadItemsMenu($event)"></app-grid-view> -->
  
    <app-grid-view #EBookingReport [customMenuTemplate]="reportListTemplate" [IsHtml]="IsHtml" [HasMenu]="HasMenu"
    (loadItemsMenu)="loadItemsMenu($event)"></app-grid-view>
  
  <ng-template #reportListTemplate let-item let-menuItems="menuItems">
   
    <!-- <li role="menuitem" *ngIf="item.ServiceId == Service.FeesEstimation && isFeesHasTransit(item.RequestId)">
        <a class="dropdown-item" (click)="getTransitByParentId(item.RequestId)">
           {{'FRONT_USER.TRANSIT_DETAILS'|translate}}
        </a>
    </li> -->
    <li role="menuitem" *ngIf="item.ServiceId == Service.TransitRequest">
        <a class="dropdown-item" (click)="getFeesByTransitId(item.RequestId)">
           {{'FRONT_USER.FEES_DETAILS'|translate}}
        </a>
    </li>

    <li role="menuitem" *ngIf="isAdmin" >
        <a class="dropdown-item" (click)="getPendingTask(item.RequestId)">
           {{'FRONT_USER.PENDING_TASKS'|translate}}
        </a>
    </li>

  </ng-template>
  </div>
</div>